// Role hierarchy for the license system.
// Order matters: controller > supermaster > master > admin > seller.

export const ROLES = ["controller", "supermaster", "master", "admin", "seller"];

export const ROLE_DETAILS = [
  { id: "controller", label: "Controller", tier: "ROOT_TIER", clearance: "Full Access" },
  { id: "supermaster", label: "Supermaster", tier: "TIER_01", clearance: "Master Mgmt" },
  { id: "master", label: "Master", tier: "TIER_02", clearance: "Admin Mgmt" },
  { id: "admin", label: "Admin", tier: "TIER_03", clearance: "Seller Mgmt" },
  { id: "seller", label: "Seller", tier: "TIER_04", clearance: "Key Generation" },
];

// Which roles each role is allowed to create. Lower levels can only create the
// next level down (strict sequence); controller can create any level.
export const CREATABLE_ROLES = {
  controller: ["controller", "supermaster", "master", "admin", "seller"],
  supermaster: ["master"],
  master: ["admin"],
  admin: ["seller"],
  seller: [],
};

// Only these roles can generate license keys.
export const KEY_CREATOR_ROLES = ["controller", "seller"];

export const ROLE_LABELS = {
  controller: "Controller",
  supermaster: "Supermaster",
  master: "Master",
  admin: "Admin",
  seller: "Seller",
};

export const ROLE_BADGE_CLASSES = {
  controller: "green",
  supermaster: "amber",
  master: "blue",
  admin: "blue",
  seller: "green",
};

export function canCreateRole(creatorRole, targetRole) {
  return (CREATABLE_ROLES[creatorRole] ?? []).includes(targetRole);
}

export function canCreateKeys(role) {
  return KEY_CREATOR_ROLES.includes(role);
}

export function canManageUsers(role) {
  return (CREATABLE_ROLES[role] ?? []).length > 0;
}
